import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';

Sentry.init({
    dsn: "https://cf3a08bf961ecc33454c7a7543f70595@o4509940205486080.ingest.de.sentry.io/4509940284719184",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration(), Sentry.captureConsoleIntegration({ levels: ['error'] })],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    enableLogs: true
})

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));